const Footer = () => {
  return (
    <div class="text-[#560319] text-center flex flex-col text-2xl mb-auto">
      <p class="mt-auto bg-[#9F5F5F]/20 w-full">
        © 2023 Programming Exercise Group 2. All rights reserved.
      </p>
    </div>
  );
};

export default Footer;
